import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Field } from "@/components/Field";
import { api } from "@/lib/api";
import { errText } from "@/lib/aadhaar";
import { useLang } from "@/context/LanguageContext";

export const ChangePassword = ({ token, onDone, forced = true }) => {
  const { L } = useLang();
  const [f, setF] = useState({ current: "", next: "", confirm: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    if (f.next !== f.confirm) return setErr(L("The two new passwords do not match.", "दोनों नए पासवर्ड मेल नहीं खाते।"));
    setBusy(true); setErr("");
    try {
      await api.post("/auth/change-password", { current_password: f.current, new_password: f.next }, { headers: { Authorization: `Bearer ${token}` } });
      onDone();
    } catch (e2) { setErr(errText(e2.response?.data?.detail, L("Could not change password", "पासवर्ड नहीं बदला जा सका"))); }
    finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
      <div className="flex items-center gap-3">
        <div className="w-11 h-11 rounded-xl bg-[#FFF1F1] grid place-items-center"><KeyRound className="w-5 h-5 text-[#FF2E63]" /></div>
        <div>
          <h1 className="text-xl font-extrabold text-[#0A192F]" data-testid="change-password-title">{L("Set your own password", "अपना पासवर्ड बनाएँ")}</h1>
          <p className="text-xs text-slate-500">{forced ? L("For your safety, the temporary password must be changed before you continue.", "आपकी सुरक्षा के लिए, आगे बढ़ने से पहले अस्थायी पासवर्ड बदलना ज़रूरी है।") : L("Choose a strong new password.", "एक मज़बूत नया पासवर्ड चुनें।")}</p>
        </div>
      </div>
      <Field id="cp_current" label={L("Temporary / current password", "अस्थायी / वर्तमान पासवर्ड")} type="password" required value={f.current} onChange={set("current")} />
      <Field id="cp_new" label={L("New password (8+ letters and numbers)", "नया पासवर्ड (8+ अक्षर और अंक)")} type="password" required minLength={8} value={f.next} onChange={set("next")} />
      <Field id="cp_confirm" label={L("Confirm new password", "नया पासवर्ड दोबारा")} type="password" required minLength={8} value={f.confirm} onChange={set("confirm")} />
      {err && <p className="text-sm text-red-600" data-testid="change-password-error">{err}</p>}
      <Button type="submit" disabled={busy} className="w-full rs-cta h-11 rounded-full" data-testid="change-password-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : L("Save and continue", "सेव करें और आगे बढ़ें")}</Button>
    </form>
  );
};
